import React from 'react'
import { useState,useEffect } from "react";
import "./SubStyle.css"
import dashboard from "../images/Acc-Dashboard.png";


const coreValuesData  = [
  {
    title: "Care-specific",
    description: "Specialist sector knowledge",
  },
  {
    title: "Clear reporting",
    description: "Numbers you can use",
  },
  {
    title: "Scalable",
    description: "One service for every home",
  },
  {
    title: "Responsive",
    description: "A team that knows your business",
  },
];

const financeServices = [
  {
    id: "01",
    title: "Management accounts",
    description:
      "Clear monthly reporting across individual homes or your whole group, with the numbers explained in plain English.",
  },
  {
    id: "02",
    title: "Payroll & pensions",
    description:
      "Accurate, dependable payroll for complex care teams—including hourly rates, overtime, enhancements and pension duties.",
  },
  {
    id: "03",
    title: "Bookkeeping & payments",
    description:
      "Day-to-day bookkeeping, reconciliations, supplier payments and fee tracking kept controlled and up to date.",
  },
  {
    id: "04",
    title: "Budgets & forecasts",
    description:
      "Occupancy-led forecasts, staffing cost models and cash-flow planning that help you make confident decisions.",
  },
  {
    id: "05",
    title: "Year-end & tax",
    description:
      "Statutory accounts, corporation tax and year-end preparation coordinated without the usual last-minute scramble.",
  },
  {
    id: "06",
    title: "Growth & acquisitions",
    description:
      "Financial due diligence, funding packs and post-acquisition reporting for operators expanding their portfolio.",
  },
];

const financeData = [
  {
    no: "01",
    heading: "Sector context",
    text: "Your numbers are reviewed by a team that understands care-sector pressures and terminology.",
  },
  {
    no: "02",
    heading: "One version of the truth",
    text: "Consistent reporting across every service, company and location in your group.",
  },
  {
    no: "03",
    heading: "Insight, not just output",
    text: "We highlight what changed, why it matters and where management attention is needed.",
  },
];

const careTypes = [
  "Residential care homes",
  "Nursing homes",
  "Domiciliary care",
  "Supported living",
  "Care home groups",
  "New care providers",
];



const Acc_Capital = () => {

   // open page on top //
           useEffect(() => {
              window.scrollTo(0, 0);
            }, []);
          
            // open page on top // 

            
  return (
    <>
     <section className="finances">

      <div className="finances-left">

        <span className="tag">
          ACCOUNTANCY BUILT AROUND CARE
        </span>

        <h1>
          Care sector
          finances, handled
          with clarity.
        </h1>

        <p>
          Specialist accounting, payroll, management accounts and forecasting
          for care homes and care groups. Get reliable numbers—and the insight
          to act on them.
        </p>

        <div className="buttons">
            <button className="primary">
            <a href='mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo'>Book a free consultation</a>
          </button>

        
          <a href="#WHAT WE DO">
            Explore our services
          </a>

        </div>

        <div className="bottom-text">
          ✓ Built for the realities of care. From occupancy and agency spend to
          payroll and fee income.
        </div>

      </div>

      <div className="finances-right">

        <img src={dashboard} alt="" />
      </div>

    </section>
     <section className="core-values" id="">
      <div className="core-values-container">
        {coreValuesData.map((item, index) => (
          <div
            key={index}
            className={`core-value-card ${
              index !== coreValuesData.length - 1 ? "border-right" : ""
            }`}
          >
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
     <header className="tc-header" id="">
      <div className="tc-container">
        {/* Navigation */}
        <nav className="tc-nav">
          <a href="#WHAT WE DO">Services</a>
          <a href="#WHY TOTAL CARE ADVISORY">Why us</a>
          <a href="#WHO WE HELP">Who we help</a>
          <a href="#LET'S TALK">Contact</a>
        </nav>
      </div>
    </header>
     <section className="finance-services" id="WHAT WE DO">
      <div className="finance-container">

        <div className="finance-header">

          <div className="finance-left">
            <span className="finance-tag">WHAT WE DO</span>

            <h2>
              Everything your care business needs from its finance team.
            </h2>
          </div>

          <div className="finance-right">
            <p>
              We provide everything from accounting and payroll to tax,
              forecasting and business consultancy—giving your organisation
              one trusted finance partner.
            </p>
          </div>

        </div>

        <div className="finance-grid">
          {financeServices.map((item) => (
            <div className="finance-card" key={item.id}>
              <span className="finance-number">{item.id}</span>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

              <a href="/">
                Learn more <span>↗</span>
              </a>
            </div>
          ))}
        </div>

      </div>
    </section>
     <section className="cf-wrapper" id="WHY TOTAL CARE ADVISORY">
      <div className="cf-layout">
        {/* Left Side */}
        <div className="cf-intro">
          <span className="cf-label">
            — WHY TOTAL CARE ADVISORY
          </span>

          <h2 className="cf-title">
            Your accountant should
            <br />
            understand more than the
            <br />
            accounts.
          </h2>

          <p className="cf-description">
            Generic reports only tell half the story. We understand how
            occupancy, local authority fees, staffing ratios, agency use and
            payroll pressures shape performance in care.
          </p>

          <button className="cf-button">
             <a href="#LET'S TALK">Meet your finance team ↗</a>
            
          </button>
        </div>

        {/* Right Side */}
        <div className="cf-services">
          {financeData.map((item) => (
            <div className="cf-card" key={item.no}>
              <span className="cf-count">{item.no}</span>

              <div className="cf-info">
                <h3>{item.heading}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
     <section className="wh-section" id="WHO WE HELP">
      <div className="wh-container">
        <div className="wh-left">
          <div className="wh-tag">
            <span className="wh-line"></span>
            <p>WHO WE HELP</p>
          </div>

          <h2>
            Accountancy that grows with
            <br />
            your care business.
          </h2>

          <p className="wh-description">
            Whether you are opening your first service or consolidating
            reporting across a growing group, we shape the support around your
            structure and ambitions.
          </p>
        </div>

        <div className="wh-right">
          {careTypes.map((item, index) => (
            <div className="wh-card" key={index}>
              <span className="check">✓</span>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
       <section className="consultation-section" id="LET'S TALK">
      <div className="consultation-container">

        {/* Left Content */}
        <div className="consultation-content">
          <span className="consultation-tag">
            <span className="line"></span>
            LET'S TALK NUMBERS
          </span>

          <h1>
            Ready for a clearer view of
            your care business?
          </h1>

          <p>
            Book a free, no-obligation consultation with our care sector
            accountancy team.
          </p>
        </div>

        {/* Right Form */}
        <div className="consultation-form">
          <h2>Book your free consultation</h2>

          <p className="form-desc">
            Tell us a little about your organisation and we'll arrange a
            convenient time to talk.
          </p>

          <div className="form-row">
            <div className="form-group">
              <label>Your Name</label>
              <input type="text" placeholder="Full name" />
            </div>

            <div className="form-group">
              <label>Work Email</label>
              <input
                type="email"
                placeholder="you@carebusiness.co.uk"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Organisation</label>
            <input type="text" placeholder="Care business name" />
          </div>

        
           <button className="consultation-btn">
            <a className="primary-pera" href='mailto:info@totalcareadvisory.com?subject=Total%20Care%20Rota%20Demo'> Request a consultation →</a>
          </button>

          <p className="bottom-text">
            Prefer email? <strong>info@totalcareadvisory.com</strong>
          </p>
        </div>

      </div>
    </section>
    </>
  )
}

export default Acc_Capital
